var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('section',{staticClass:"section is-large"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content has-text-centered"},[_c('h1',[_vm._v(_vm._s(("Guardados " + _vm.actual + " de " + _vm.total))+" "),_c('i',{staticClass:"fa fa-spinner fa-spin",staticStyle:{"font-size":"48px"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-759d79c9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/LoaderInfo.vue
// module id = 3447
// module chunks = 0